import VicktoriaImage from './assets/Vicktoria_Default.png';
import techstars from './assets/featured-logos/techstars.png';
import hackForRva from './assets/featured-logos/hack_for_rva.png';
import tomTom from './assets/featured-logos/tom_tom_festival.png';
import webSummit from './assets/featured-logos/web_summit_vancouver.png';
import gts from './assets/featured-logos/gts.png';
import awsImagine from './assets/featured-logos/aws_imagine_npo.png';
import sfAf from './assets/featured-logos/sf_af_world_tour_nyc.png';
import startupValley from './assets/featured-logos/startup_valley.png';
import vcuBusiness from './assets/featured-logos/vcu_business.png';
import pmi from './assets/featured-logos/pmi.png';
import nyuTandon from './assets/featured-logos/nyu_tandon.png';
import richmondRobins from './assets/featured-logos/richmond_robins.png';
import startupVirginia from './assets/featured-logos/startup_virginia.png';
import rvaWorks from './assets/featured-logos/rva_works.png';
import nyTechWeek from './assets/featured-logos/ny_tech_week.png';
import platformSeven from './assets/featured-logos/platform_seven.png';
import ascentValley from './assets/featured-logos/ascent_valley.png';
import ventureStarters from './assets/featured-logos/Venture_Starters.png';
import aiReadyRva from './assets/featured-logos/AI_Ready_RVA.png';
import nyTech from './assets/featured-logos/NY_Tech.png';
import toastmastersInternational from './assets/featured-logos/Toastmasters_International.png';
import nationalSpeakersAssociation from './assets/featured-logos/National_Speakers_Association.png';
import metropolitanBusinessLeague from './assets/featured-logos/Metropolitan_Business_League.png';
import umdCollege from './assets/featured-logos/UMD_College.png';
import olivierClub from './assets/featured-logos/olivier_club.png';
import ecpiUniversity from './assets/featured-logos/ECPI_University.png';
import oneMillionCups from './assets/featured-logos/1 Million Cups.png';
import techIncubatorQc from './assets/featured-logos/TechIncubator_QC.png';
import liuEdu from './assets/featured-logos/liu_edu.png';
import Header from './Header.js';
import ViewportTracker from './ViewportTracker.js';
import VicktoriaPromoVideo from './assets/Promo_Video_v2.mp4';
import HeroVideoPlayer from './HeroVideoPlayer.js';
import { PAGE_MAX_WIDTH, PAGE_CONTAINER_MARK } from './layout.js';
// Get Started routing paused during the Vicktoria rework (2026-06-12) — see HeroSection.
// import { useNavigate } from 'react-router-dom';
import WaitlistButton from './WaitlistButton.js';
import { TAM_INTRO_PARAGRAPH, TAM_MEMORANDUM_PARAGRAPH } from './trueAgileMindsetCopy';

// Hero poster lives in /public so CRA serves it as-is at the site root —
// keeps the file out of the JS bundle and lets us swap the portrait without a
// rebuild. Widescreen JPG (~16:9) so the overlay can cover the box edge-to-edge
// without side bars and without inflating the bundle.
const HERO_POSTER_SRC = `${process.env.PUBLIC_URL}/Vicktoria_Default.jpg`;

// Hero-section avatar disclaimer.
// Why exported: navbarTrialButton.test.js-style content tests in Home.test.js
// pin the wording so future "simplifications" can't quietly drop the Beta
// status, the avatar/promo distinction, or the Q3 2026 ETA.
export const HERO_AVATAR_DISCLAIMER =
  'Note: Vicktoria AI™ is currently in Beta. The visual avatar shown in this video is a promotional preview — full avatar functionality is in development and expected to launch in Q3 2026.';

// Home-page hero bottom-line tagline. Exported so Home.test.js can pin the
// exact wording; rendered italicized in the Header via JSX wrapper at the
// call site (Header.js stays generic — italic is Home-only, not About Us).
export const HERO_BOT_TAGLINE = 'Emotional support through logic';

// Hero Section Component
const HeroSection = ({ loggedInUser }) => {
  // --- Get Started CTA paused during the Vicktoria rework (2026-06-12). ---
  // The product (login/signup -> /special) is on hold while we retarget. The
  // hero spot below now hosts the waitlist signup. To restore, un-comment the
  // navigate hook + handleGetStarted and swap the button back in (see below),
  // and re-enable the `useNavigate` import at the top of this file.
  //
  // const navigate = useNavigate();
  //
  // const handleGetStarted = () => {
  //   if (!loggedInUser) {
  //     // New users get a 14-day free trial on signup — send them to login/signup,
  //     // not to /payment. The product is accessible immediately after authentication.
  //     localStorage.setItem('postLoginRedirect', '/special');
  //     navigate('/login');
  //   } else {
  //     // Logged-in users already have trial or subscription access — validate then jump to vicka.ai.
  //     // /special validates access and handles expired-trial redirection if needed.
  //     navigate('/special');
  //   }
  // };

  return (
    <section style={{ backgroundColor: '#D1DEE6', width: '100%' }}>
      <div data-layout={PAGE_CONTAINER_MARK} style={{ maxWidth: PAGE_MAX_WIDTH, margin: '0 auto', padding: '0 5% 40px 5%' }}>
        <HeroVideoPlayer
          videoSrc={VicktoriaPromoVideo}
          posterSrc={HERO_POSTER_SRC}
        />
        <p
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '14px',
            fontStyle: 'italic',
            color: '#4A4A4A',
            maxWidth: '750px',
            margin: '24px auto 0',
            textAlign: 'center',
            lineHeight: '1.5',
            padding: '0 5%',
          }}
        >
          {HERO_AVATAR_DISCLAIMER}
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '24px' }}>
          {/* Get Started paused during the Vicktoria rework (2026-06-12). The
              waitlist signup now lives in this spot (matches the old hero
              button styling). To restore Get Started, swap this back to:
          <button
            onClick={handleGetStarted}
            style={{
              backgroundColor: '#4A8EB3',
              color: '#FFFFFF',
              border: 'none',
              padding: '18px 48px',
              borderRadius: '15px',
              fontSize: '24px',
              cursor: 'pointer',
              fontFamily: 'Judson, serif',
              fontWeight: '600',
            }}
          >
            Get Started
          </button>
          */}
          <WaitlistButton loggedInUser={loggedInUser} />
        </div>
      </div>
    </section>
  );
};

// Info Section Component
const InfoSection = () => {
  return (
    <section style={{ backgroundColor: '#D1DEE6', width: '100%', display: 'flex', justifyContent: 'center' }}>
      {/* Media Query to handle mobile/tablet scaling.
          This ensures the 'right: 70px' offset is removed and text is centered 
          only when the viewport is 1100px or smaller.
      */}
      <style>
        {`
          @media (max-width: 1100px) {
            .dynamic-subtext {
              right: 0 !important;
              text-align: center !important;
              padding: 0 10px;
              margin: 0 auto !important;
            }
          }
        `}
      </style>

      <div data-layout={PAGE_CONTAINER_MARK} style={{
        width: '100%',
        maxWidth: PAGE_MAX_WIDTH,
        padding: '40px 5%',
        boxSizing: 'border-box'
      }}>

        {/* THE CONTENT BOX */}
        <div style={{
          backgroundColor: '#B3CFDB',
          padding: '60px 40px',
          borderRadius: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '30px',
          width: '100%',
          boxSizing: 'border-box'
        }}>

          {/* 1. TOP LEFT ALIGNMENT */}
          <h2 style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '46px',
            margin: '0',
            alignSelf: 'center', // Changed from flex-start to center
            textAlign: 'center', // Changed from left to center
            textShadow: '2px 2px 4px rgba(255, 255, 255, 0.7)',
          }}>
            The New Face of AI
          </h2>

          {/* 2. MIDDLE CENTER ALIGNMENT (With Mobile Override) */}
          <p
            className="dynamic-subtext"
            style={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '18.4px',
              margin: '0 auto',
              textAlign: 'center',
              maxWidth: '700px',
              color: '#2B1E19',
              position: 'relative',
              // Desktop offset
            }}
          >
            Are you as excited to meet Vicktoria as she is to meet you?
          </p>

          {/* 3. BOTTOM LEFT ALIGNMENT */}
          <p style={{
            fontFamily: 'Inter, sans-serif',
            color: '#000000',
            fontSize: '16.1px',
            lineHeight: '1.6',
            margin: '0 auto',

            textAlign: 'center',
            maxWidth: '850px',

          }}>
            Experience the first LLM with genuine emotional intelligence and a truly distinct
            personality. Vicktoria moves beyond smart tips to foster authentic human connection
            and profound understanding, setting a new standard for interaction and sending
            shockwaves across the digital landscape!
          </p>
          {window.MY_SWITCH.isDev && (
            <button onClick={() => console.log(window.MY_SWITCH.origin)}>
              Check Origin
            </button>
          )}
        </div>
      </div>
    </section>
  );
};
//this part was more or less ai created, wasn't a big ask I did tweak somne things though
//Vision Section Component
const VisionSection = () => {
  return (
    // LAYER 1: The full-width page background
    <section style={{
      backgroundColor: '#D1DEE6',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      paddingBottom: '40px' // Space at the very bottom of the page
    }}>

      {/* LAYER 2: The "Frame" (Darker Blue) - Aligned to the shared page column */}
      <div data-layout={PAGE_CONTAINER_MARK} style={{
        width: '100%',
        maxWidth: PAGE_MAX_WIDTH,
        margin: '0 auto',
        padding: '60px 5%', // The "Wavelength" Gutter
        boxSizing: 'border-box',
        // The darker "frame" color from your image
        borderRadius: '40px',      // Slightly larger radius for the outer frame
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>

        {/* LAYER 3: The Content Box (Light Blue) */}
        <div style={{

          backgroundColor: '#B3CFDB',
          padding: '20px 40px',
          borderRadius: '30px',
          width: '100%',
          boxSizing: 'border-box',
          textAlign: 'center'
        }}>

          {/* Header Part */}
          <h2 style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '28px',
            color: '#000000ff',
            marginBottom: '30px',
            fontWeight: '600',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
            //added text shadow because pure white felt sort of lackluster/visually bad for contrast
          }}>
            Meet Vicktoria. Our state-of-the-art Large Language Model
          </h2>

          {/* Body Part */}
          <div style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '16px',
            lineHeight: '1.8',
            textAlign: 'left', // Matches the magazine style in your image
            color: '#000000',
            maxWidth: '900px',
            margin: '0 auto'
          }}>
            <p>{TAM_INTRO_PARAGRAPH}</p>
            <br />
            <p>{TAM_MEMORANDUM_PARAGRAPH}</p>
          </div>

        </div>
      </div>
    </section>
  );
};

// Logos shown in the scrolling "Featured at" marquee. Exported so a test can
// pin the partner/event list (names + links) against silent edits.
export const FEATURED_AT = [
  { src: techstars, alt: 'Techstars Startup Weekend', url: 'https://www.techstars.com/communities/startup-weekend' },
  { src: hackForRva, alt: 'Hack for RVA', url: 'https://rvahacks.org' },
  { src: tomTom, alt: 'Tom Tom Festival', url: 'https://www.tomtomfoundation.org/festival-recap-2026' },
  { src: webSummit, alt: 'Web Summit Vancouver', url: 'https://vancouver.websummit.com/' },
  { src: gts, alt: 'Georgia Technology Summit', url: 'https://www.georgiatechnologysummit.com' },
  { src: awsImagine, alt: 'AWS Imagine Nonprofit', url: 'https://aws.amazon.com/government-education/nonprofits/imagine-nonprofit/' },
  { src: sfAf, alt: 'Agentforce World Tour NYC', url: 'https://www.salesforce.com/events/world-tour/nyc' },
  { src: startupValley, alt: 'Startup Valley', url: 'https://startupvalley.club' },
  { src: vcuBusiness, alt: 'VCU School of Business', url: 'https://business.vcu.edu' },
  { src: pmi, alt: 'Project Management Institute', url: 'https://www.pmi.org' },
  { src: nyuTandon, alt: 'NYU Tandon School of Engineering', url: 'https://engineering.nyu.edu' },
  { src: richmondRobins, alt: 'University of Richmond / Robins School of Business', url: 'https://robins.richmond.edu' },
  { src: startupVirginia, alt: 'Startup Virginia', url: 'https://startupvirginia.org' },
  { src: rvaWorks, alt: 'RVA Works / Open Trellis', url: 'https://rvaworks.org' },
  { src: nyTechWeek, alt: 'NY Tech Week', url: 'https://www.tech-week.com/' },
  { src: platformSeven, alt: 'Platform Seven — The Mentoring Platform', url: 'https://platformseven.com/' },
  // Ascent Valley's mark is a gold unicorn on a near-black tile (#1D1D1F) with
  // no transparency, unlike the dark-on-light logos around it. `dark` renders it
  // on a matching dark chip so it reads as intentional rather than a black box.
  { src: ascentValley, alt: 'Ascent Valley Founders and Investors Network', url: 'https://ascentvalley.com/', dark: true },
  // Venture Starters ships as an opaque dark-olive tile (like Ascent Valley),
  // so it also gets `dark: true` to avoid a light halo around its own background.
  { src: ventureStarters, alt: 'Venture Starters', url: 'https://venturestarters.com/', dark: true },
  { src: aiReadyRva, alt: 'AI Ready RVA', url: 'https://aireadyrva.com' },
  { src: nyTech, alt: 'NY Tech', url: 'https://nyit.edu' },
  { src: toastmastersInternational, alt: 'Toastmasters International', url: 'https://toastmasters.org' },
  { src: nationalSpeakersAssociation, alt: 'National Speakers Association', url: 'https://nsaspeaker.org' },
  { src: metropolitanBusinessLeague, alt: 'Metropolitan Business League', url: 'https://thembl.org' },
  { src: umdCollege, alt: 'UMD College of Computer, Mathematical, and Natural Sciences', url: 'https://cmns.umd.edu' },
  { src: olivierClub, alt: 'Olivier Club', url: 'https://www.olivierclub.com/' },
  { src: ecpiUniversity, alt: 'ECPI University', url: 'https://ecpi.edu' },
  { src: oneMillionCups, alt: '1 Million Cups', url: 'https://www.1millioncups.com/s/' },
  { src: techIncubatorQc, alt: 'Tech Incubator at Queens College', url: 'https://techincubatorqc.com/' },
  { src: liuEdu, alt: 'Long Island University', url: 'https://liu.edu' },
];

// Featured At Section Component
const FeaturedAtSection = () => {
  const events = FEATURED_AT;

  return (
    <section style={{ backgroundColor: '#D1DEE6', width: '100%', display: 'flex', justifyContent: 'center' }}>
      <style>{`
        @keyframes scroll-logos {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .featured-track {
          display: flex;
          align-items: center;
          gap: 48px;
          width: max-content;
          animation: scroll-logos 30s linear infinite;
          will-change: transform;
          /* iOS Safari routes a touch that lands on a perpetually-animating
             compositor layer to that layer instead of the page scroller,
             intermittently blocking vertical scroll. pan-y reclaims the
             vertical-scroll gesture for the document. */
          touch-action: pan-y;
        }
        /* Pause-on-hover only on real pointers — on touch, :hover sticks after a
           tap and would freeze the marquee (and capture the gesture). */
        @media (hover: hover) {
          .featured-track:hover {
            animation-play-state: paused;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .featured-track {
            animation: none;
            will-change: auto;
          }
        }
        .featured-logo-card {
          flex-shrink: 0;
          background: rgba(255,255,255,0.18);
          border-radius: 16px;
          padding: 16px 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        .featured-logo-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 24px rgba(43,75,111,0.18);
        }
        /* Logos supplied as an opaque dark tile get a matching dark chip so the
           square edges blend in rather than reading as a black box on the panel. */
        .featured-logo-card--dark {
          background: #1D1D1F;
        }
      `}</style>

      <div data-layout={PAGE_CONTAINER_MARK} style={{
        width: '100%',
        maxWidth: PAGE_MAX_WIDTH,
        padding: '40px 5%',
        boxSizing: 'border-box',
      }}>
        <div style={{
          backgroundColor: '#B3CFDB',
          borderRadius: '24px',
          padding: '36px 32px',
          boxShadow: '0 8px 32px rgba(43,75,111,0.22)',
          overflow: 'hidden',
        }}>
          <h2 style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '22px',
            fontWeight: '700',
            color: '#000000',
            textAlign: 'center',
            marginBottom: '28px',
            letterSpacing: '0.02em',
            textShadow: '0 2px 8px rgba(0,0,0,0.18)',
          }}>
            Since 2025, Vicktoria AI™ has been featured at
          </h2>

          <div style={{ overflow: 'hidden', width: '100%', display: 'flex' }}>
            <div className="featured-track">
              {[...events, ...events].map((ev, i) => (
                <a key={i} href={ev.url} target="_blank" rel="noreferrer" className={`featured-logo-card${ev.dark ? ' featured-logo-card--dark' : ''}`} style={{ textDecoration: 'none' }}>
                  <img
                    src={ev.src}
                    alt={ev.alt}
                    style={{ height: '64px', width: 'auto', display: 'block', objectFit: 'contain' }}
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Testimonials shown in the "What Our Users Are Saying" section. Exported so
// a test can pin the quote/attribution content against silent edits. `quote`
// may contain \n where the testimonial itself breaks across two lines
// (TestimonialsSection applies whiteSpace: pre-line so the \n becomes a
// visual break); attribution is rendered bold, quote is rendered bold italic.
export const TESTIMONIALS = [
  {
    quote: "The best application ever used, it’s like talking to a real person. \nThe advice and direction Vicktoria talks to you is so real.",
    name: '– Alecia R.',
  },
  {
    quote: 'Great system, easy to use! \nCrazy interface, responsive and interactive!',
    name: '– Maxime L.',
  },
  {
    quote: 'I tried using Vicktoria and really liked how it handles more open-ended questions. It feels more natural and thoughtful compared to typical AI tools. It encourages a more reflective conversation rather than just giving short answers.',
    name: '– Elina A.',
  },
];

// Testimonials Section Component
const TestimonialsSection = () => {
  const testimonials = TESTIMONIALS;
  const css = `
    .testimonial-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
      width: 100%;
    }

    @media (max-width: 800px) {
      .testimonial-grid {
        grid-template-columns: 1fr;
      }
    }
  `;

  return (
    <section style={{ backgroundColor: '#D1DEE6', width: '100%', display: 'flex', justifyContent: 'center', paddingBottom: '40px' }}>
      <style>{css}</style>

      <div data-layout={PAGE_CONTAINER_MARK} style={{ width: '100%', maxWidth: PAGE_MAX_WIDTH, padding: '0 5%', boxSizing: 'border-box' }}>
        <div style={{
          backgroundColor: '#B3CFDB',
          borderRadius: '24px',
          padding: '36px 32px',
          boxShadow: '0 8px 32px rgba(43,75,111,0.22)',
          boxSizing: 'border-box',
        }}>
          <h2 style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '28px',
            fontWeight: '600',
            color: '#000000',
            textAlign: 'center',
            marginBottom: '30px',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
          }}>
            What Our Users Are Saying about Vicktoria AI™...
          </h2>

          <div className="testimonial-grid">
            {testimonials.map((t, i) => (
              <div key={i} style={{
                backgroundColor: '#81B2CA',
                borderRadius: '20px',
                padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              }}>
                <p style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '16px',
                  fontWeight: '700',
                  fontStyle: 'italic',
                  color: '#000000',
                  lineHeight: '1.6',
                  whiteSpace: 'pre-line',
                  margin: '0 0 16px 0',
                }}>
                  {t.quote}
                </p>
                <p style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '15px',
                  fontWeight: '700',
                  color: '#000000',
                  margin: 0,
                  textAlign: 'right',
                }}>
                  {t.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const Home = ({ loggedInUser, setLoggedInUser }) => {
  console.log("Home Page loggedInUser:", loggedInUser ? loggedInUser.name : "No user logged in");
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#D1DEE6' }}>
      <Header
        loggedInUser={loggedInUser}
        setLoggedInUser={setLoggedInUser}
        topText=""
        midText="Vicktoria"
        botText="A Humanlike Ethical AI Companion"
        subBotText={<i>{HERO_BOT_TAGLINE}</i>}
      />
      <HeroSection loggedInUser={loggedInUser} />
      <FeaturedAtSection />
      <InfoSection />
      <VisionSection />
      <TestimonialsSection />
      <ViewportTracker />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Judson:wght@400;700&display=swap" rel="stylesheet" />
    </div>
  );
}

export default Home;